import { render, staticRenderFns } from "./ImportClients.vue?vue&type=template&id=2816270c"
import script from "./ImportClients.vue?vue&type=script&lang=js"
export * from "./ImportClients.vue?vue&type=script&lang=js"
import style0 from "./ImportClients.vue?vue&type=style&index=0&id=2816270c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports